import { Box, Typography, useTheme } from "@mui/material";
import CustomButton from "../../../../../components/CustomButton";
import BottomSheetLayout from "../../../../../components/BottomSheetLayout";
import { Link } from "react-router-dom";
import {
  convertToJalali,
  flattenObject,
} from "../../../../../../utils/functions";
import CalendarCheck from "../../../../../../media/images/icons/calendar-check";
import CallOutlineSVG from "../../../../../../media/images/icons/call-outline";
import { ITrackingDto } from "../../../../../../types/trackingPage";
import { useEffect } from "react";

interface Props {
  onDismiss: () => void;
  open: boolean;
  trackingData: ITrackingDto;
}

export default function BarDetailsBottomSheet(props: Props) {
  const { onDismiss, open, trackingData } = props;

  const theme = useTheme();

  const getPdfTrigger = async (object: any) => {
    await fetch(`https://deyetspapi.bita24.com/api/Report/GetPdf`, {
      method: "POST",
      credentials: "omit",
      body: JSON.stringify(object),
      mode: "no-cors",
      headers: {
        "Content-Type": "application/json",
        charset: "utf-8",
      },
    })
      .then((response) => response)
      .then((resp) => {
        if (resp.status !== 200) {
          // console.log(resp);
        } else {
          alert("در پردازش فایل خطایی به وجود آمده است");
        }
      })
      .catch((err) => {
        console.error(err);
        alert("در پردازش فایل خطایی به وجود آمده است" + err);
      });
  };

  useEffect(() => {
    if (open) {
      const { id, ...rest } = trackingData;
      getPdfTrigger({
        id: trackingData.licenseNr,
        RepName: "KarenTarabarnet",
        ...flattenObject(rest),
      });
    }
  }, [open]);
  const handleDownload = async () => {
    if (!(trackingData.status === 5)) return;

    const fileUrl = `https://update.bita24.com/ApplicationReports/KarenTarabarnet/${trackingData.licenseNr}.pdf`;

    try {
      const response = await fetch(fileUrl);
      if (!response.ok) {
        throw new Error("Failed to fetch file");
      }
      const blob = await response.blob();

      // Create a download link programmatically
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${trackingData.licenseNr}.pdf`; // Set the file name
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };

  return (
    <BottomSheetLayout height="100%" onDismiss={onDismiss} open={open}>
      <Box
        sx={{
          flex: "1",
          overflow: "auto",
          padding: "8px",
        }}
      >
        <Box
          sx={{
            backgroundColor: "bgColor.white",
            borderRadius: "16px",
            boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.2)",
            padding: "8px",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            flex: "1",
          }}
        >
          <Box
            sx={{
              mt: 1,
              borderRadius: "8px",
              backgroundColor: "bgColor.grey100",
              display: "flex",
              justifyContent: "space-between",
              boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1) inset",
              padding: "8px 6px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <CalendarCheck size={22} color={theme.palette.textColor.main} />
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                دریافت مجوز:{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                fontSize: "14px",
              }}
            >
              {trackingData.operatorInfo?.license?.insertDateTime
                ? convertToJalali(
                    trackingData?.operatorInfo?.license?.insertDateTime
                  )
                : ""}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                flex: "1",
                borderRadius: "8px",
                backgroundColor: trackingData?.dol?.draftDate
                  ? "#f2f2cd"
                  : "bgColor.grey100",
                display: "flex",
                justifyContent: "space-between",
                boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1) inset",
                padding: "8px 6px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <CalendarCheck size={22} color={theme.palette.textColor.main} />
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  صدور حواله:{" "}
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: "14px",
                }}
              >
                {trackingData?.dol
                  ? convertToJalali(trackingData?.dol?.draftDate)
                  : ""}
              </Typography>
            </Box>
            {/* {
              <CustomButton
                disabled={!(trackingData.status === 5)}
                onClick={() => handleDownload()}
                title="چاپ"
                bgColor="success.main"
                fSize="14px"
                px="16px"
                py="4px"
                borderRadius="6px"
              />
            } */}
          </Box>

          <Box
            sx={{
              display: "flex",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                flex: "1",
                borderRadius: "8px",
                backgroundColor: trackingData?.bol?.bolDate
                  ? "#dcf2cd"
                  : "bgColor.grey100",
                display: "flex",
                justifyContent: "space-between",
                boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1) inset",
                padding: "8px 6px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <CalendarCheck size={22} color={theme.palette.textColor.main} />
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  صدور بارنامه:{" "}
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: "14px",
                }}
              >
                {convertToJalali(trackingData?.bol?.bolDate)}
              </Typography>
            </Box>

            {/* <CustomButton
              disabled={!(trackingData.status === 5)}
              onClick={() => handleDownload()}
              title="چاپ"
              bgColor="success.main"
              fSize="14px"
              px="16px"
              py="4px"
              borderRadius="6px"
            /> */}
          </Box>
          <Box
            sx={{
              flex: "1",
              borderRadius: "8px",
              backgroundColor: "bgColor.grey100",
              display: "flex",
              justifyContent: "space-between",
              boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1) inset",
              padding: "8px 6px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <CalendarCheck size={22} color={theme.palette.textColor.main} />
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                حضور در محل بارگیری:
              </Typography>
            </Box>
            <Typography
              sx={{
                fontSize: "14px",
              }}
            >
              {trackingData?.shipStatusDt1
                ? convertToJalali(trackingData?.shipStatusDt1)
                : ""}
            </Typography>
          </Box>

          <Box
            sx={{
              flex: "1",
              borderRadius: "8px",
              backgroundColor: "bgColor.grey100",
              display: "flex",
              justifyContent: "space-between",
              boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1) inset",
              padding: "8px 6px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <CalendarCheck size={22} color={theme.palette.textColor.main} />
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                شروع حرکت:
              </Typography>
            </Box>
            <Typography
              sx={{
                fontSize: "14px",
              }}
            >
              {trackingData?.shipStatusDt2
                ? convertToJalali(trackingData?.shipStatusDt2)
                : ""}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                flex: "1",
                borderRadius: "8px",
                backgroundColor: "bgColor.grey100",
                display: "flex",
                justifyContent: "space-between",
                boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1) inset",
                padding: "8px 6px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <CalendarCheck size={22} color={theme.palette.textColor.main} />
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  حضور در محل تخلیه:
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: "14px",
                }}
              >
                {trackingData?.shipStatusDt3
                  ? convertToJalali(trackingData?.shipStatusDt3)
                  : ""}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                flex: "1",
                borderRadius: "8px",
                backgroundColor: "bgColor.grey100",
                display: "flex",
                justifyContent: "space-between",
                boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1) inset",
                padding: "8px 6px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <CalendarCheck size={22} color={theme.palette.textColor.main} />
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  رسید تحویل کالا:
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: "14px",
                }}
              >
                {trackingData?.shipStatusDt5
                  ? convertToJalali(trackingData?.shipStatusDt5)
                  : ""}
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              mt: 1,
              boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1) inset",
              borderRadius: "8px",
              backgroundColor: "bgColor.grey100",
              padding: "6px",
              display: "flex",
              flexDirection: "column",
              gap: "4px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "4px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "600",
                  color: "primary.main",
                }}
              >
                گیرنده کالا:
              </Typography>

              {trackingData?.orderInfo?.receiverAddress?.tel ? (
                <Link
                  to={`tel:${trackingData?.orderInfo?.receiverAddress?.tel}`}
                  style={{
                    display: "flex",
                    gap: "3px",
                    borderColor: theme.palette.primary.main,
                    borderRadius: "6px",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    alignItems: "center",
                    backgroundColor: theme.palette.background.default,
                    padding: "6px",
                  }}
                >
                  <CallOutlineSVG
                    size={16}
                    color={theme.palette.primary.main}
                  />
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "primary.main",
                    }}
                  >
                    تماس{" "}
                  </Typography>
                </Link>
              ) : (
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >
                  {""}
                </Typography>
              )}
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                noWrap
                sx={{
                  fontSize: "14px",
                }}
              >
                {trackingData?.orderInfo?.receiverInfo?.fullName || "---------"}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              mt: 1,
              boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1) inset",
              borderRadius: "8px",
              backgroundColor: "bgColor.grey100",
              padding: "6px",
              display: "flex",
              flexDirection: "column",
              gap: "4px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "4px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "600",
                  color: "primary.main",
                }}
              >
                فرستنده کالا:
              </Typography>

              {trackingData.orderInfo?.senderAddress?.tel ? (
                <Link
                  to={`tel:${trackingData?.orderInfo?.senderAddress?.tel}`}
                  style={{
                    display: "flex",
                    gap: "3px",
                    borderColor: theme.palette.primary.main,
                    borderRadius: "6px",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    alignItems: "center",
                    backgroundColor: theme.palette.background.default,
                    padding: "6px",
                  }}
                >
                  <CallOutlineSVG
                    size={16}
                    color={theme.palette.primary.main}
                  />
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "primary.main",
                    }}
                  >
                    تماس{" "}
                  </Typography>
                </Link>
              ) : (
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >
                  {""}
                </Typography>
              )}
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                noWrap
                sx={{
                  fontSize: "14px",
                }}
              >
                {trackingData?.orderInfo?.senderInfo?.fullName || "---------"}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              mt: 1,
              boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1) inset",
              borderRadius: "8px",
              backgroundColor: "bgColor.grey100",
              padding: "6px",
              display: "flex",
              flexDirection: "column",
              gap: "4px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "4px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "600",
                  color: "primary.main",
                }}
              >
                شرکت حمل:
              </Typography>

              {trackingData?.orderInfo?.receiverAddress?.tel ? (
                <Link
                  to={`tel:${trackingData?.orderInfo?.receiverAddress?.tel}`}
                  style={{
                    display: "flex",
                    gap: "3px",
                    borderColor: theme.palette.primary.main,
                    borderRadius: "6px",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    alignItems: "center",
                    backgroundColor: theme.palette.background.default,
                    padding: "6px",
                  }}
                >
                  <CallOutlineSVG
                    size={16}
                    color={theme.palette.primary.main}
                  />
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "primary.main",
                    }}
                  >
                    تماس{" "}
                  </Typography>
                </Link>
              ) : (
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >
                  {""}
                </Typography>
              )}
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                noWrap
                sx={{
                  fontSize: "14px",
                }}
              >
                {trackingData?.orderInfo?.companyName || "---------"}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          padding: "4px 8px",
        }}
      >
        <CustomButton
          mt="8px"
          onClick={onDismiss}
          title="بستن"
          width="100%"
          justifyContent="center"
          bgColor="secondary.main"
          fSize="14px"
          fWeight="700"
          textColor="#fff"
          px="6px"
          py="12px"
          borderRadius="6px"
        />
      </Box>
    </BottomSheetLayout>
  );
}
